import {ChevronRight, type LucideIcon} from "lucide-react";

import {
	Collapsible,
	CollapsibleContent,
	CollapsibleTrigger,
} from "@/components/ui/collapsible";
import {
	SidebarGroup,
	SidebarGroupLabel,
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
	SidebarMenuSub,
	SidebarMenuSubButton,
	SidebarMenuSubItem,
} from "@/components/ui/sidebar";
import {NavLink} from "react-router-dom";

type Item = {
	title: string
	url: string
	icon?: LucideIcon
	isActive?: boolean
	items?: {
		title: string
		url: string
	}[]
}

export function NavMain(
	{
		items,
	}: {
		items: Item[]
	}) {
	const renderItem = (item: Item) => {
		if (item.items) {
			return ((
				<Collapsible
					key={item.title}
					defaultOpen={item.isActive}
					className="group/collapsible"
				>
					<SidebarMenuItem>
						<CollapsibleTrigger className="w-full">
							<SidebarMenuButton tooltip={item.title}>
								{item.icon && <item.icon/>}
								<span>{item.title}</span>
								<ChevronRight
									className="ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90"/>
							</SidebarMenuButton>
						</CollapsibleTrigger>
						<CollapsibleContent>
							<SidebarMenuSub>
								{item.items.map((subItem) => (
									<SidebarMenuSubItem key={subItem.title}>
										<NavLink key={subItem.url} to={subItem.url}>
											<SidebarMenuSubButton>
												<span>{subItem.title}</span>
											</SidebarMenuSubButton>
										</NavLink>
									</SidebarMenuSubItem>
								))}
							</SidebarMenuSub>
						</CollapsibleContent>
					</SidebarMenuItem>
				</Collapsible>
			));
		} else {
			return (
				<NavLink key={item.url} to={item.url} className="flex gap-2 items-center">
					<SidebarMenuButton>
						{item.icon && <item.icon/>}
						<span>{item.title}</span>
					</SidebarMenuButton>
				</NavLink>);
		}
	};
	return (
		<SidebarGroup>
			<SidebarGroupLabel>Platform</SidebarGroupLabel>
			<SidebarMenu>
				{items.map((item) => renderItem(item))}
			</SidebarMenu>
		</SidebarGroup>
	);
}
